export const SAVING_SETUP_COMPANY = 'SAVING_SETUP_COMPANY';
export const SET_LOADED_STATE = 'SET_LOADED_STATE';
export const SET_COMPANY_STATE = 'SET_COMPANY_STATE';

export const savingSetupCompany = (saving) => (dispatch) => {
    dispatch({ type: SAVING_SETUP_COMPANY, saving });
};

export const setLoadedState = (loadedState) => (dispatch) => {
    dispatch({ type: SET_LOADED_STATE, loadedState });
};

export const setCompanyState = (company) => (dispatch) => {
    dispatch({ type: SET_COMPANY_STATE, company });
};

export default {
    SAVING_SETUP_COMPANY,
    SET_LOADED_STATE,
    SET_COMPANY_STATE,
    savingSetupCompany,
    setLoadedState,
    setCompanyState,
};
